import { Download, Mail, Printer, Send, XCircle } from "lucide-react";
import React, { useMemo } from "react";
import { Button, Card, Separator } from "randmarcomps";
import { useUser } from "../../../hooks/useUser";
import CancelPurchaseOrder from "./CancelPurchaseOrder";
import CancelRequisition from "./CancelRequisition";
import GeneratePDFWrapper from "./GeneratePDFWrapper";
import SendByEmailWrapper from "./SendByEmailWrapper";
import SendPurchaseOrderToSupplier from "./SendPurchaseOrderToSupplier";

interface IProps {
  documentNumber: string;
}

const DocumentActions: React.FC<IProps> = ({ documentNumber }) => {
  const { isSuperAdmin } = useUser();

  const isPurchaseOrder = useMemo(
    () => documentNumber.startsWith("PO") && documentNumber.length === 9,
    [documentNumber]
  );
  const isRequisition = useMemo(
    () => documentNumber.startsWith("RQ") && documentNumber.length === 9,
    [documentNumber]
  );

  return (
    <Card className="mx-1 my-2 max-w-[250px] bg-white">
      <div className="flex flex-col space-y-1 p-2">
        <p className="ml-1 text-sm font-medium text-primary">General</p>
      <GeneratePDFWrapper documentNumber={documentNumber} action="open">
        <Button variant="ghost" className="w-full justify-start">
          <Printer className="mr-2 h-4 w-4" />
          Print
        </Button>
      </GeneratePDFWrapper>
      <GeneratePDFWrapper documentNumber={documentNumber} action="download">
        <Button variant="ghost" className="w-full justify-start">
          <Download className="mr-2 h-4 w-4" />
          Download
        </Button>
      </GeneratePDFWrapper>
      <SendByEmailWrapper documentNumber={documentNumber}>
        <Button variant="ghost" className="w-full justify-start">
          <Mail className="mr-2 h-4 w-4" />
          Send by Email
        </Button>
      </SendByEmailWrapper>

      <Separator className="my-2" />

      <p className="ml-1 text-sm font-medium text-primary">{documentNumber}</p>

      {isPurchaseOrder && (
        <>
          <CancelPurchaseOrder purchaseOrderNumber={documentNumber}>
            <Button variant="ghost" className="w-full justify-start">
              <XCircle className="mr-2 h-4 w-4" />
              Cancel Order
            </Button>
          </CancelPurchaseOrder>
          {isSuperAdmin && (
            <SendPurchaseOrderToSupplier purchaseOrderNumber={documentNumber}>
              <Button variant="ghost" className="w-full justify-start">
                <Send className="mr-2 h-4 w-4" />
                Send PO to Manufacturer
              </Button>
            </SendPurchaseOrderToSupplier>
          )}
        </>
      )}
      {isRequisition && (
        <CancelRequisition requisitionNumber={documentNumber}>
          <Button variant="ghost" className="w-full justify-start">
            <XCircle className="mr-2 h-4 w-4" />
            Cancel Draft
          </Button>
        </CancelRequisition>
      )}
      </div>
    </Card>
  );
};

export default DocumentActions;
